import getOffset from './get-offset';
import Animation from './animation';

let curAnimation = null;

export default function scrollTo(elem, options = {}) {
	const html = document.documentElement;
	const body = document.body;
	const top = typeof elem === 'number' ? elem : getOffset(elem).top;
	const sourceScroll = options.startValue = html.scrollTop || body.scrollTop;
	const targetScroll = options.endValue = top;

	if (options.speed) {
		const dist = Math.abs(sourceScroll - targetScroll);

		if (typeof options.speed === 'function') {
			options.duration = options.speed(dist);
		} else {
			let speed = parseFloat(options.speed);
			if (speed < 0) {
				speed = 0;
			}
			options.duration = speed / 1000 * dist;
		}
	}

	if (curAnimation !== null) {
		curAnimation.stop();
	}

	curAnimation = new Animation(
		(y) => {
			html.scrollTop = y;
			body.scrollTop = y;
		},
		options
	);
	curAnimation.start();
}
